import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { FormatTemplatePills } from '../format-template-pills.component';
import { messages } from '../format-template.messages';

interface IFormatTemplateListItemProps {
  template: IFormatTemplate;
  // The global list hides them: a catalog family's document-wide range spans all bands
  // and reads as noise; a custom template's range genuinely describes applicability.
  showPills: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canSetGlobal: boolean;
  onPreview: (template: IFormatTemplate) => void;
  onEdit: (template: IFormatTemplate) => void;
  onDelete: (template: IFormatTemplate) => void;
  onToggleGlobal: (template: IFormatTemplate, value: boolean) => void;
}

export const FormatTemplateListItem: React.FC<IFormatTemplateListItemProps> = ({
  template,
  showPills,
  canEdit,
  canDelete,
  canSetGlobal,
  onPreview,
  onEdit,
  onDelete,
  onToggleGlobal,
}) => (
  <Card variant="outlined">
    <Box display="flex" alignItems="center" justifyContent="space-between" p={1.5}>
      <Box minWidth={0}>
        <Typography variant="subtitle2" noWrap>{template.name}</Typography>
        {showPills && (
          <Box mt={0.5}>
            <FormatTemplatePills template={template} />
          </Box>
        )}
      </Box>
      <Box display="flex" alignItems="center" flexShrink={0} ml={1}>
        {canSetGlobal && (
          <FormControlLabel
            control={(
              <Switch
                size="small"
                color="primary"
                checked={template.scope === 'SYSTEM'}
                onChange={e => onToggleGlobal(template, e.target.checked)}
              />
            )}
            label={<Typography variant="body2"><IntlMsg {...messages.globalToggleLabel} /></Typography>}
          />
        )}
        <Button size="small" startIcon={<VisibilityIcon />} onClick={() => onPreview(template)}>
          <IntlMsg {...messages.preview} />
        </Button>
        {canEdit && (
          <Button size="small" startIcon={<EditIcon />} onClick={() => onEdit(template)}>
            <IntlMsg {...messages.edit} />
          </Button>
        )}
        {canDelete && (
          <Button size="small" startIcon={<DeleteIcon />} onClick={() => onDelete(template)}>
            <IntlMsg {...messages.delete} />
          </Button>
        )}
      </Box>
    </Box>
  </Card>
);
